/**
 *
 * ================ THIS FILE IS GENERATED ===============
 *
 * No changes should be made directly in this file - your change will be reflected
 * here after you make your changes directly in the source files and run
 * npm run locale:generate <folder>
 *
 * Documentation here:
 *
 */

import * as tx from "@transifex/native";

export default {
    brand: {
        admin: {
            products: {
                title: tx.t("Product catalog settings", {
                    _context: "Brand admin menu - Subsection title - Admin page menu Product Catalog Settings submenu",
                    _tags: "frontend,brand,admin,products",
                    _key: "brand.admin.products.title",
                }),
                barcode_management_label: tx.t("Barcode management", {
                    _context:
                        "Brand admin Products menu - subsection label - redirects to Barcode Management configuration and settings",
                    _tags: "frontend,brand,admin,products",
                    _key: "brand.admin.products.barcode_management_label",
                }),
                barcode_management_desc: tx.t("Manage your barcode settings.", {
                    _context:
                        "Brand admin Products menu - subsection desciption - redirects to Barcode Management configuration and settings",
                    _tags: "frontend,brand,admin,products",
                    _key: "brand.admin.products.barcode_management_desc",
                }),
                barcode_printing_label: tx.t("Barcode printing", {
                    _context:
                        "Brand admin Products menu - subsection label - redirects to Barcode Printing configuration and settings",
                    _tags: "frontend,brand,admin,products",
                    _key: "brand.admin.products.barcode_printing_label",
                }),
                barcode_printing_desc: tx.t("Print your barcodes.", {
                    _context:
                        "Brand admin Products menu - subsection desciption - redirects to Barcode Printing configuration and settings",
                    _tags: "frontend,brand,admin,products",
                    _key: "brand.admin.products.barcode_printing_desc",
                }),
                manage_catalogs_label: tx.t("Manage catalogs", {
                    _context:
                        "Brand admin Products menu - subsection label - redirects to Linesheet/Catalogs configuration and settings",
                    _tags: "frontend,brand,admin,products",
                    _key: "brand.admin.products.manage_catalogs_label",
                }),
                manage_linesheets_label: tx.t("Manage linesheets", {
                    _context:
                        "Brand admin Products menu - subsection label - redirects to Linesheet/Catalogs configuration and settings",
                    _tags: "frontend,brand,admin,products",
                    _key: "brand.admin.products.manage_linesheets_label",
                }),
                manage_linesheets_desc: tx.t("Create and edit custom templates.", {
                    _context:
                        "Brand admin Products menu - subsection description - redirects to Linesheet/Catalogs configuration and settings",
                    _tags: "frontend,brand,admin,products",
                    _key: "brand.admin.products.manage_linesheets_desc",
                }),
                product_banners_label: tx.t("Product banners", {
                    _context:
                        "Brand admin Products menu - subsection label - redirects to Product Banners configuration and settings",
                    _tags: "frontend,brand,admin,products",
                    _key: "brand.admin.products.product_banners_label",
                }),
                product_banners_desc: tx.t("Create and manage banners for products.", {
                    _context:
                        "Brand admin Products menu - subsection description - redirects to Product Banners configuration and settings",
                    _tags: "frontend,brand,admin,products",
                    _key: "brand.admin.products.product_banners_desc",
                }),
                product_gallery_label: tx.t("Product gallery", {
                    _context:
                        "Brand admin Products menu - subsection description - redirects to Product Gallery configuration and settings",
                    _tags: "frontend,brand,admin,products",
                    _key: "brand.admin.products.product_gallery_label",
                }),
                product_gallery_desc: tx.t("Edit, merchandise and enable products.", {
                    _context:
                        "Brand admin Products menu - subsection description - redirects to Product Gallery configuration and settings",
                    _tags: "frontend,brand,admin,products",
                    _key: "brand.admin.products.product_gallery_desc",
                }),
            },
            data: {
                title: tx.t("Data", {
                    _context: "Brand admin menu - Subsection title - Admin page menu Data submenu",
                    _tags: "frontend,brand,admin,data",
                    _key: "brand.admin.data.title",
                }),
                company_data_label: tx.t("Company data", {
                    _context:
                        "Brand admin Data menu - subsection label - redirects to Company Data configuration and settings",
                    _tags: "frontend,brand,admin,data",
                    _key: "brand.admin.data.company_data_label",
                }),
                company_data_desc: tx.t("Upload and download company data.", {
                    _context:
                        "Brand admin Data menu - subsection description - redirects to Company Data configuration and settings",
                    _tags: "frontend,brand,admin,data",
                    _key: "brand.admin.data.company_data_desc",
                }),
                buyer_data_label: tx.t("Buyer data", {
                    _context:
                        "Brand admin Data menu - subsection label - redirects to Buyer Data configuration and settings",
                    _tags: "frontend,brand,admin,data",
                    _key: "brand.admin.data.buyer_data_label",
                }),
                buyer_data_desc: tx.t("Upload and download buyer data.", {
                    _context:
                        "Brand admin Data menu - subsection description - redirects to Buyer Data configuration and settings",
                    _tags: "frontend,brand,admin,data",
                    _key: "brand.admin.data.buyer_data_desc",
                }),
                inventory_data_label: tx.t("Inventory data", {
                    _context:
                        "Brand admin Data menu - subsection label - redirects to Inventory Data configuration and settings",
                    _tags: "frontend,brand,admin,data",
                    _key: "brand.admin.data.inventory_data_label",
                }),
                inventory_data_desc: tx.t("Upload and download inventory data.", {
                    _context:
                        "Brand admin Data menu - subsection description - redirects to Inventory Data configuration and settings",
                    _tags: "frontend,brand,admin,data",
                    _key: "brand.admin.data.inventory_data_desc",
                }),
                product_data_label: tx.t("Product data", {
                    _context:
                        "Brand admin Data menu - subsection label - redirects to Product Data configuration and settings",
                    _tags: "frontend,brand,admin,data",
                    _key: "brand.admin.data.product_data_label",
                }),
                product_data_desc: tx.t("Upload and download product data.", {
                    _context:
                        "Brand admin Data menu - subsection description - redirects to Product Data configuration and settings",
                    _tags: "frontend,brand,admin,data",
                    _key: "brand.admin.data.product_data_desc",
                }),
                size_pack_data_label: tx.t("Size pack data", {
                    _context:
                        "Brand admin Data menu - subsection label - redirects to Size Pack Data configuration and settings",
                    _tags: "frontend,brand,admin,data",
                    _key: "brand.admin.data.size_pack_data_label",
                }),
                size_pack_data_desc: tx.t("Upload and download size pack data.", {
                    _context:
                        "Brand admin Data menu - subsection description - redirects to Size Pack Data configuration and settings",
                    _tags: "frontend,brand,admin,data",
                    _key: "brand.admin.data.size_pack_data_desc",
                }),
                pricing_label: tx.t("Pricing", {
                    _context:
                        "Brand admin Data menu - subsection label - redirects to Pricing configuration and settings",
                    _tags: "frontend,brand,admin,data",
                    _key: "brand.admin.data.pricing_label",
                }),
                pricing_desc: tx.t("Upload and download price sheets.", {
                    _context:
                        "Brand admin Data menu - subsection description - redirects to Pricing configuration and settings",
                    _tags: "frontend,brand,admin,data",
                    _key: "brand.admin.data.pricing_desc",
                }),
                archives_label: tx.t("Archives", {
                    _context:
                        "Brand admin Data menu - subsection label - redirects to Archives configuration and settings",
                    _tags: "frontend,brand,admin,data",
                    _key: "brand.admin.data.archives_label",
                }),
                archives_desc: tx.t("Archive and unarchive products, orders and companies.", {
                    _context:
                        "Brand admin Data menu - subsection description - redirects to Archives configuration and settings",
                    _tags: "frontend,brand,admin,data",
                    _key: "brand.admin.data.archives_desc",
                }),
            },
            settings: {
                title: tx.t("Settings", {
                    _context: "Brand admin menu - Subsection title - Admin page menu Settings submenu",
                    _tags: "frontend,brand,admin,settings",
                    _key: "brand.admin.settings.title",
                }),
                manage_data_sync_label: tx.t("Manage data sync", {
                    _context:
                        "Brand admin Settings menu - subsection label - redirects to Manage Data Sync configuration and settings",
                    _tags: "frontend,brand,admin,settings",
                    _key: "brand.admin.settings.manage_data_sync_label",
                }),
                manage_data_sync_desc: tx.t(
                    "Sync product data and view connection status and dates across all of your mapped retailers.",
                    {
                        _context:
                            "Brand admin Settings menu - subsection description - redirects to Manage Data Sync configuration and settings",
                        _tags: "frontend,brand,admin,settings",
                        _key: "brand.admin.settings.manage_data_sync_desc",
                    },
                ),
                brand_settings_label: tx.t("Brand settings", {
                    _context:
                        "Brand admin Settings menu - subsection label - redirects to Brand Settings configuration and settings",
                    _tags: "frontend,brand,admin,settings",
                    _key: "brand.admin.settings.brand_settings_label",
                }),
                brand_settings_desc: tx.t("Manage contact info, weekly digest email list and subteams.", {
                    _context:
                        "Brand admin Settings menu - subsection description - redirects to Brand Settings configuration and settings",
                    _tags: "frontend,brand,admin,settings",
                    _key: "brand.admin.settings.brand_settings_desc",
                }),
                branded_login_label: tx.t("Branded login", {
                    _context:
                        "Brand admin Settings menu - subsection label - redirects to Brand Login configuration and settings",
                    _tags: "frontend,brand,admin,settings",
                    _key: "brand.admin.settings.branded_login_label",
                }),
                branded_login_desc: tx.t("Enter branded login info for this brand.", {
                    _context:
                        "Brand admin Settings menu - subsection description - redirects to Brand Login configuration and settings",
                    _tags: "frontend,brand,admin,settings",
                    _key: "brand.admin.settings.branded_login_desc",
                }),
                api_management_label: tx.t("API management", {
                    _context:
                        "Brand admin Settings menu - subsection label - redirects to API Management configuration and settings",
                    _tags: "frontend,brand,admin,settings",
                    _key: "brand.admin.settings.api_management_label",
                }),
                api_management_desc: tx.t("Retrieve API keys and approve or disable application tokens.", {
                    _context:
                        "Brand admin Settings menu - subsection description - redirects to API Management configuration and settings",
                    _tags: "frontend,brand,admin,settings",
                    _key: "brand.admin.settings.api_management_desc",
                }),
                delivery_windows_label: tx.t("Delivery windows", {
                    _context:
                        "Brand admin Settings menu - subsection label - redirects to Delivery Windows configuration and settings",
                    _tags: "frontend,brand,admin,settings",
                    _key: "brand.admin.settings.delivery_windows_label",
                }),
                delivery_windows_desc: tx.t("Set defined delivery windows.", {
                    _context:
                        "Brand admin Settings menu - subsection description - redirects to Delivery Windows configuration and settings",
                    _tags: "frontend,brand,admin,settings",
                    _key: "brand.admin.settings.delivery_windows_desc",
                }),
                user_groups_label: tx.t("Customer and user groups", {
                    _context:
                        "Brand admin Settings menu - subsection label - redirects to Customer & User groups configuration and settings",
                    _tags: "frontend,brand,admin,settings",
                    _key: "brand.admin.settings.user_groups_label",
                }),
                user_groups_desc: tx.t("Manage your groups and product visibility rules.", {
                    _context:
                        "Brand admin Settings menu - subsection description - redirects to Customer & User groups configuration and settings",
                    _tags: "frontend,brand,admin,settings",
                    _key: "brand.admin.settings.user_groups_desc",
                }),
                payment_processing_label: tx.t("Manage payment processing", {
                    _context:
                        "Brand admin Settings menu - subsection label - redirects to Payment Processing configuration and settings",
                    _tags: "frontend,brand,admin,settings",
                    _key: "brand.admin.settings.payment_processing_label",
                }),
                payment_processing_desc: tx.t("Manage payment processing accounts.", {
                    _context:
                        "Brand admin Settings menu - subsection description - redirects to Payment Processing configuration and settings",
                    _tags: "frontend,brand,admin,settings",
                    _key: "brand.admin.settings.payment_processing_desc",
                }),
                marketplace_preferences_label: tx.t("Marketplace preferences", {
                    _context:
                        "Brand admin Settings menu - subsection label - redirects to Marketplace preferences configuration and settings",
                    _tags: "frontend,brand,admin,settings",
                    _key: "brand.admin.settings.marketplace_preferences_label",
                }),
                marketplace_preferences_desc: tx.t("Manage preferences for NuORDER marketplace visibility", {
                    _context:
                        "Brand admin Settings menu - subsection description - redirects to Marketplace preferences configuration and settings",
                    _tags: "frontend,brand,admin,settings",
                    _key: "brand.admin.settings.marketplace_preferences_desc",
                }),
                inventory_settings_label: tx.t("Inventory settings", {
                    _context:
                        "Brand admin Settings menu - subsection label - redirects to Inventory Settings configuration and settings",
                    _tags: "frontend,brand,admin,settings",
                    _key: "brand.admin.settings.inventory_settings_label",
                }),
                inventory_settings_desc: tx.t("Set preferences and thresholds and manage warehouses.", {
                    _context:
                        "Brand admin Settings menu - subsection description - redirects to Inventory Settings configuration and settings",
                    _tags: "frontend,brand,admin,settings",
                    _key: "brand.admin.settings.inventory_settings_desc",
                }),
                order_rules_label: tx.t("Order min max rules", {
                    _context:
                        "Brand admin Settings menu - subsection label - redirects to Order Rules configuration and settings",
                    _tags: "frontend,brand,admin,settings",
                    _key: "brand.admin.settings.order_rules_label",
                }),
                order_rules_desc: tx.t("Set rules for minimum or maximum values on orders.", {
                    _context:
                        "Brand admin Settings menu - subsection description - redirects to Order Rules configuration and settings",
                    _tags: "frontend,brand,admin,settings",
                    _key: "brand.admin.settings.order_rules_desc",
                }),
                order_settings_label: tx.t("Order settings", {
                    _context:
                        "Brand admin Settings menu - subsection label - redirects to Order Settings configuration and settings",
                    _tags: "frontend,brand,admin,settings",
                    _key: "brand.admin.settings.order_settings_label",
                }),
                order_settings_desc: tx.t("Set order preferences, splitting rules and Terms and Conditions.", {
                    _context:
                        "Brand admin Settings menu - subsection description - redirects to Order Settings configuration and settings",
                    _tags: "frontend,brand,admin,settings",
                    _key: "brand.admin.settings.order_settings_desc",
                }),
                custom_templates_label: tx.t("Order export templates", {
                    _context:
                        "Brand admin Settings menu - subsection label - redirects to Order Export Templates configuration and settings",
                    _tags: "frontend,brand,admin,settings",
                    _key: "brand.admin.settings.custom_templates_label",
                }),
                custom_templates_desc: tx.t("Create and edit templates for order exports.", {
                    _context:
                        "Brand admin Settings menu - subsection description - redirects to Order Export Templates configuration and settings",
                    _tags: "frontend,brand,admin,settings",
                    _key: "brand.admin.settings.custom_templates_desc",
                }),
                order_export_info_label: tx.t("Order export information", {
                    _context:
                        "Brand admin Settings menu - subsection label - redirects to Order Export Info configuration and settings",
                    _tags: "frontend,brand,admin,settings",
                    _key: "brand.admin.settings.order_export_info_label",
                }),
                order_export_info_desc: tx.t("Create or edit the order export CSV file.", {
                    _context:
                        "Brand admin Settings menu - subsection description - redirects to Order Export Info configuration and settings",
                    _tags: "frontend,brand,admin,settings",
                    _key: "brand.admin.settings.order_export_info_desc",
                }),
                ats_reports_label: tx.t("ATS report templates", {
                    _context:
                        "Brand admin Settings menu - subsection label - redirects to ATS Report Templates configuration and settings",
                    _tags: "frontend,brand,admin,settings",
                    _key: "brand.admin.settings.ats_reports_label",
                }),
                ats_reports_desc: tx.t("Create and edit ATS templates.", {
                    _context:
                        "Brand admin Settings menu - subsection description - redirects to ATS Report Templates configuration and settings",
                    _tags: "frontend,brand,admin,settings",
                    _key: "brand.admin.settings.ats_reports_desc",
                }),
                payment_history_label: tx.t("Payment history", {
                    _context:
                        "Brand admin Settings menu - subsection label - redirects to Payment History configuration and settings",
                    _tags: "frontend,brand,admin,settings",
                    _key: "brand.admin.settings.payment_history_label",
                }),
                payment_history_desc: tx.t("Export order payment history.", {
                    _context:
                        "Brand admin Settings menu - subsection description - redirects to Payment History configuration and settings",
                    _tags: "frontend,brand,admin,settings",
                    _key: "brand.admin.settings.payment_history_desc",
                }),
                stitchlabs_integration_label: tx.t("Stitch Labs integration", {
                    _context:
                        "Brand admin Settings menu - subsection label - redirects to StitchLabs Integration configuration and settings",
                    _tags: "frontend,brand,admin,settings",
                    _key: "brand.admin.settings.stitchlabs_integration_label",
                }),
                stitchlabs_integration_desc: tx.t("Set up an integration with the Stitch Labs ERP.", {
                    _context:
                        "Brand admin Settings menu - subsection description - redirects to StitchLabs Integration configuration and settings",
                    _tags: "frontend,brand,admin,settings",
                    _key: "brand.admin.settings.stitchlabs_integration_desc",
                }),
                matterport_integration_label: tx.t("Matterport integration", {
                    _context:
                        "Brand admin Settings menu - subsection label - redirects to Matterport Integration configuration and settings",
                    _tags: "frontend,brand,admin,settings",
                    _key: "brand.admin.settings.matterport_integration_label",
                }),
                matterport_integration_desc: tx.t(
                    "Set up an integration with Matterport for the 3D walk through in Sites Manager.",
                    {
                        _context:
                            "Brand admin Settings menu - subsection description - redirects to Matterport Integration configuration and settings",
                        _tags: "frontend,brand,admin,settings",
                        _key: "brand.admin.settings.matterport_integration_desc",
                    },
                ),
                marketplace_profile_label: tx.t("Manage Marketplace profile", {
                    _context:
                        "Brand admin Settings menu - subsection label - redirects to Manage Marketplace Profile configuration and settings",
                    _tags: "frontend,brand,admin,settings",
                    _key: "brand.admin.settings.marketplace_profile_label",
                }),
                marketplace_profile_desc: tx.t("Manage brand profile in the Marketplace.", {
                    _context:
                        "Brand admin Settings menu - subsection description - redirects to Manage Marketplace Profile configuration and settings",
                    _tags: "frontend,brand,admin,settings",
                    _key: "brand.admin.settings.marketplace_profile_desc",
                }),
                online_trade_show_label: tx.t("Guest buyer visibility", {
                    _context:
                        "Brand admin Settings menu - subsection label - redirects to Guest Buyer Visibility configuration and settings",
                    _tags: "frontend,brand,admin,settings",
                    _key: "brand.admin.settings.online_trade_show_label",
                }),
                online_trade_show_desc: tx.t("Set up product visibility for guest buyers.", {
                    _context:
                        "Brand admin Settings menu - subsection description - redirects to Guest Buyer Visibility configuration and settings",
                    _tags: "frontend,brand,admin,settings",
                    _key: "brand.admin.settings.online_trade_show_desc",
                }),
                shipping_management_label: tx.t("Manage shipping", {
                    _context:
                        "Brand admin Settings menu - subsection label - redirects to Manage Shipping configuration and settings",
                    _tags: "frontend,brand,admin,settings",
                    _key: "brand.admin.settings.shipping_management_label",
                }),
                shipping_management_desc: tx.t("Connect your warehouses to different shipping carriers.", {
                    _context:
                        "Brand admin Settings menu - subsection description - redirects to Manage Shipping configuration and settings",
                    _tags: "frontend,brand,admin,settings",
                    _key: "brand.admin.settings.shipping_management_desc",
                }),
                manage_shipping_promotions_label: tx.t("Manage shipping promotions", {
                    _context:
                        "Brand admin Settings menu - subsection label - redirects to Manage Shipping Promotions configuration and settings",
                    _tags: "frontend,brand,admin,settings",
                    _key: "brand.admin.settings.manage_shipping_promotions_label",
                }),
                manage_shipping_promotions_desc: tx.t("Create and edit shipping promotions.", {
                    _context:
                        "Brand admin Settings menu - subsection description - redirects to Manage Shipping Promotions configuration and settings",
                    _tags: "frontend,brand,admin,settings",
                    _key: "brand.admin.settings.manage_shipping_promotions_desc",
                }),
                manage_sizes_label: tx.t("Manage sizes", {
                    _context:
                        "Brand admin Settings menu - subsection label - redirects to Manage Sizes configuration and settings",
                    _tags: "frontend,brand,admin,settings",
                    _key: "brand.admin.settings.manage_sizes_label",
                }),
                manage_sizes_desc: tx.t("Manage product sizes.", {
                    _context:
                        "Brand admin Settings menu - subsection description - redirects to Manage Sizes configuration and settings",
                    _tags: "frontend,brand,admin,settings",
                    _key: "brand.admin.settings.manage_sizes_desc",
                }),
                terms_and_conditions_label: tx.t("Usage Terms and Conditions", {
                    _context:
                        "Brand admin Settings menu - subsection label - redirects to T&C configuration and settings",
                    _tags: "frontend,brand,admin,settings",
                    _key: "brand.admin.settings.terms_and_conditions_label",
                }),
                terms_and_conditions_desc: tx.t("Manage Terms and Conditions for buyers.", {
                    _context:
                        "Brand admin Settings menu - subsection description - redirects to T&C configuration and settings",
                    _tags: "frontend,brand,admin,settings",
                    _key: "brand.admin.settings.terms_and_conditions_desc",
                }),
                pricing_label: tx.t("Pricing", {
                    _context:
                        "Brand admin Settings menu - subsection label - redirects to Pricing configuration and settings",
                    _tags: "frontend,brand,admin,settings",
                    _key: "brand.admin.settings.pricing_label",
                }),
                pricing_desc: tx.t("Manage pricing configurations.", {
                    _context:
                        "Brand admin Settings menu - subsection description - redirects to Pricing configuration and settings",
                    _tags: "frontend,brand,admin,settings",
                    _key: "brand.admin.settings.pricing_desc",
                }),
            },
            users: {
                title: tx.t("Users", {
                    _context: "Brand admin menu - Subsection title - Admin page menu Users submenu",
                    _tags: "frontend,brand,admin,users",
                    _key: "brand.admin.users.title",
                }),
                brand_users_label: tx.t("Manage brand users", {
                    _context:
                        "Brand admin Users menu - subsection label - redirects to Manage Brand Users configuration and settings",
                    _tags: "frontend,brand,admin,users",
                    _key: "brand.admin.users.brand_users_label",
                }),
                brand_users_desc: tx.t("Create, edit and delete brand users.", {
                    _context:
                        "Brand admin Users menu - subsection description - redirects to Manage Brand Users configuration and settings",
                    _tags: "frontend,brand,admin,users",
                    _key: "brand.admin.users.brand_users_desc",
                }),
                product_visibility_report_label: tx.t("Product visibility report", {
                    _context:
                        "Brand admin Users menu - subsection label - redirects to Product Visibility Report configuration and settings",
                    _tags: "frontend,brand,admin,users",
                    _key: "brand.admin.users.product_visibility_report_label",
                }),
                product_visibility_report_desc: tx.t("Diagnose product visibility issues by user.", {
                    _context:
                        "Brand admin Users menu - subsection description - redirects to Product Visibility Report configuration and settings",
                    _tags: "frontend,brand,admin,users",
                    _key: "brand.admin.users.product_visibility_report_desc",
                }),
            },
            promotions: {
                title: tx.t("Promotions", {
                    _context: "Brand admin menu - Subsection title - Admin page menu Promotions submenu",
                    _tags: "frontend,brand,admin,promotions",
                    _key: "brand.admin.promotions.title",
                }),
                manage_promotions_label: tx.t("Manage Promotions", {
                    _context:
                        "Brand admin Promotions menu - subsection label - redirects to Promotions configuration and settings",
                    _tags: "frontend,brand,admin,promotions",
                    _key: "brand.admin.promotions.manage_promotions_label",
                }),
                manage_promotions_desc: tx.t("Create, edit and deactivate Promotions.", {
                    _context:
                        "Brand admin Promotions menu - subsection description - redirects to Promotions configuration and settings",
                    _tags: "frontend,brand,admin,promotions",
                    _key: "brand.admin.promotions.manage_promotions_desc",
                }),
                actions: {
                    promotion_updated_successfully: tx.t("Promotion updated successfully", {
                        _context: "Create Promotion - snackbar message - promotion updated successfully",
                        _tags: "frontend,brand,admin,promotions,actions",
                        _key: "brand.admin.promotions.actions.promotion_updated_successfully",
                    }),
                    promotion_created_successfully: tx.t("Promotion created successfully", {
                        _context: "Create Promotion - snackbar message - promotion created successfully",
                        _tags: "frontend,brand,admin,promotions,actions",
                        _key: "brand.admin.promotions.actions.promotion_created_successfully",
                    }),
                },
                eligibility_rules: {
                    add_rule_label: tx.t("Add rule", {
                        _context: "Eligibility Rules - button label - add rule",
                        _tags: "frontend,brand,admin,promotions,eligibility_rules",
                        _key: "brand.admin.promotions.eligibility_rules.add_rule_label",
                    }),
                    amount_rule: {
                        double_validation_message: tx.t("Please enter a valid amount (e.g. 1, 2.0, 9.99)", {
                            _context: "Eligibility Rules Amount Rule - validation message - valid amount",
                            _tags: "frontend,brand,admin,promotions,eligibility_rules,amount_rule",
                            _key: "brand.admin.promotions.eligibility_rules.amount_rule.double_validation_message",
                        }),
                        number_validation_message: tx.t("Please enter a valid quantity (e.g. 1, 20, 999)", {
                            _context: "Eligibility Rules Amount Rule - validation message - valid quantity",
                            _tags: "frontend,brand,admin,promotions,eligibility_rules,amount_rule",
                            _key: "brand.admin.promotions.eligibility_rules.amount_rule.number_validation_message",
                        }),
                        value_more_than_min_amount_message: tx.t("Value should be more than 'Minimum amount' value", {
                            _context:
                                "Eligibility Rules Amount Rule - validation message - value more than minimum amount",
                            _tags: "frontend,brand,admin,promotions,eligibility_rules,amount_rule",
                            _key: "brand.admin.promotions.eligibility_rules.amount_rule.value_more_than_min_amount_message",
                        }),
                        value_more_than_min_quantity_message: tx.t(
                            "Value should be more than 'Minimum quantity' value",
                            {
                                _context:
                                    "Eligibility Rules Amount Rule - validation message - value more than minimum quantity",
                                _tags: "frontend,brand,admin,promotions,eligibility_rules,amount_rule",
                                _key: "brand.admin.promotions.eligibility_rules.amount_rule.value_more_than_min_quantity_message",
                            },
                        ),
                        enter_value_message: tx.t("Please enter a value", {
                            _context: "Eligibility Rules Amount Rule - validation message - enter value",
                            _tags: "frontend,brand,admin,promotions,eligibility_rules,amount_rule",
                            _key: "brand.admin.promotions.eligibility_rules.amount_rule.enter_value_message",
                        }),
                        add_order_amount_message: tx.t("Please add order amount or shipped amount rule", {
                            _context:
                                "Eligibility Rules Amount Rule - validation message - add order amount or shipped amount rule",
                            _tags: "frontend,brand,admin,promotions,eligibility_rules,amount_rule",
                            _key: "brand.admin.promotions.eligibility_rules.amount_rule.add_order_amount_message",
                        }),
                        add_conditional_message: tx.t(
                            "Conditional date range is required for the Shipped amount rule",
                            {
                                _context:
                                    "Eligibility Rules Amount Rule - validation message - conditional date range required for shipped amount rule",
                                _tags: "frontend,brand,admin,promotions,eligibility_rules,amount_rule",
                                _key: "brand.admin.promotions.eligibility_rules.amount_rule.add_conditional_message",
                            },
                        ),
                        end_date_greater_than_start_message: tx.t("End date should be greater than Start date", {
                            _context:
                                "Eligibility Rules Amount Rule - validation message - end date greater than start date",
                            _tags: "frontend,brand,admin,promotions,eligibility_rules,amount_rule",
                            _key: "brand.admin.promotions.eligibility_rules.amount_rule.end_date_greater_than_start_message",
                        }),
                        start_date_in_past_message: tx.t("Start date should be in the past", {
                            _context: "Eligibility Rules Amount Rule - validation message - start date in past",
                            _tags: "frontend,brand,admin,promotions,eligibility_rules,amount_rule",
                            _key: "brand.admin.promotions.eligibility_rules.amount_rule.start_date_in_past_message",
                        }),
                        end_date_in_past_message: tx.t("End date should be in the past", {
                            _context: "Eligibility Rules Amount Rule - validation message - end date in past",
                            _tags: "frontend,brand,admin,promotions,eligibility_rules,amount_rule",
                            _key: "brand.admin.promotions.eligibility_rules.amount_rule.end_date_in_past_message",
                        }),
                        empty_field_message: tx.t("Field can not be empty", {
                            _context: "Eligibility Rules Amount Rule - validation message - field cannot be empty",
                            _tags: "frontend,brand,admin,promotions,eligibility_rules,amount_rule",
                            _key: "brand.admin.promotions.eligibility_rules.amount_rule.empty_field_message",
                        }),
                        no_fields_chosen_message: tx.t("You should select at least 1 option", {
                            _context: "Eligibility Rules Amount Rule - validation message - select at least one option",
                            _tags: "frontend,brand,admin,promotions,eligibility_rules,amount_rule",
                            _key: "brand.admin.promotions.eligibility_rules.amount_rule.no_fields_chosen_message",
                        }),
                        value_more_than_at_least_message: tx.t("Value should be more than 'At least' value", {
                            _context:
                                "Eligibility Rules Amount Rule - validation message - value more than 'At least' value",
                            _tags: "frontend,brand,admin,promotions,eligibility_rules,amount_rule",
                            _key: "brand.admin.promotions.eligibility_rules.amount_rule.value_more_than_at_least_message",
                        }),
                        value_less_than_at_most_message: tx.t("Value should be less than 'At most' value", {
                            _context:
                                "Eligibility Rules Amount Rule - validation message - value less than 'At most' value",
                            _tags: "frontend,brand,admin,promotions,eligibility_rules,amount_rule",
                            _key: "brand.admin.promotions.eligibility_rules.amount_rule.value_less_than_at_most_message",
                        }),
                        at_least_label: tx.t("At least", {
                            _context: "Eligibility Rules Amount Rule - label - at least",
                            _tags: "frontend,brand,admin,promotions,eligibility_rules,amount_rule",
                            _key: "brand.admin.promotions.eligibility_rules.amount_rule.at_least_label",
                        }),
                        at_most_label: tx.t("At most", {
                            _context: "Eligibility Rules Amount Rule - label - at most",
                            _tags: "frontend,brand,admin,promotions,eligibility_rules,amount_rule",
                            _key: "brand.admin.promotions.eligibility_rules.amount_rule.at_most_label",
                        }),
                        minimum_amount_label: tx.t("Minimum amount:", {
                            _context: "Eligibility Rules Amount Rule - label - minimum amount",
                            _tags: "frontend,brand,admin,promotions,eligibility_rules,amount_rule",
                            _key: "brand.admin.promotions.eligibility_rules.amount_rule.minimum_amount_label",
                        }),
                        maximum_amount_label: tx.t("Maximum amount:", {
                            _context: "Eligibility Rules Amount Rule - label - maximum amount",
                            _tags: "frontend,brand,admin,promotions,eligibility_rules,amount_rule",
                            _key: "brand.admin.promotions.eligibility_rules.amount_rule.maximum_amount_label",
                        }),
                        minimum_quantity_label: tx.t("Minimum quantity:", {
                            _context: "Eligibility Rules Amount Rule - label - minimum quantity",
                            _tags: "frontend,brand,admin,promotions,eligibility_rules,amount_rule",
                            _key: "brand.admin.promotions.eligibility_rules.amount_rule.minimum_quantity_label",
                        }),
                        maximum_quantity_label: tx.t("Maximum quantity:", {
                            _context: "Eligibility Rules Amount Rule - label - maximum quantity",
                            _tags: "frontend,brand,admin,promotions,eligibility_rules,amount_rule",
                            _key: "brand.admin.promotions.eligibility_rules.amount_rule.maximum_quantity_label",
                        }),
                    },
                    threshold_message: {
                        helpers: {
                            value_less_than_max_amount_message: tx.t(
                                "Value should be less than 'Maximum amount' value",
                                {
                                    _context:
                                        "Eligibility Rules Amount Rule - validation message - value less than 'Maximum amount' value",
                                    _tags: "frontend,brand,admin,promotions,eligibility_rules,threshold_message,helpers",
                                    _key: "brand.admin.promotions.eligibility_rules.threshold_message.helpers.value_less_than_max_amount_message",
                                },
                            ),
                            value_less_than_max_quantity_message: tx.t(
                                "Value should be less than 'Maximum quantity' value",
                                {
                                    _context:
                                        "Eligibility Rules Amount Rule - validation message - value less than 'Maximum quantity' value",
                                    _tags: "frontend,brand,admin,promotions,eligibility_rules,threshold_message,helpers",
                                    _key: "brand.admin.promotions.eligibility_rules.threshold_message.helpers.value_less_than_max_quantity_message",
                                },
                            ),
                            enter_value_message: tx.t("Please enter a value", {
                                _context:
                                    "ThresholdMessageHelpers - error - Please enter a value error message for threshold validation",
                                _tags: "frontend,brand,admin,promotions,eligibility_rules,threshold_message,helpers",
                                _key: "brand.admin.promotions.eligibility_rules.threshold_message.helpers.enter_value_message",
                            }),
                            enter_valid_amount_message: tx.t("Please enter a valid amount (e.g. 1, 2.0, 9.99)", {
                                _context:
                                    "ThresholdMessageHelpers - error - Please enter a valid amount error message for threshold validation",
                                _tags: "frontend,brand,admin,promotions,eligibility_rules,threshold_message,helpers",
                                _key: "brand.admin.promotions.eligibility_rules.threshold_message.helpers.enter_valid_amount_message",
                            }),
                            enter_valid_quantity_message: tx.t("Please enter a valid quantity (e.g. 1, 20, 999)", {
                                _context:
                                    "ThresholdMessageHelpers - error - Please enter a valid quantity error message for threshold validation",
                                _tags: "frontend,brand,admin,promotions,eligibility_rules,threshold_message,helpers",
                                _key: "brand.admin.promotions.eligibility_rules.threshold_message.helpers.enter_valid_quantity_message",
                            }),
                            value_less_than_at_least_message: tx.t("Value should be less than 'At Least' value", {
                                _context:
                                    "ThresholdMessageHelpers - error - Value should be less than 'At Least' value error message for threshold validation",
                                _tags: "frontend,brand,admin,promotions,eligibility_rules,threshold_message,helpers",
                                _key: "brand.admin.promotions.eligibility_rules.threshold_message.helpers.value_less_than_at_least_message",
                            }),
                            value_less_than_minimum_amount_message: tx.t(
                                "Value should be less than 'Minimum amount' value",
                                {
                                    _context:
                                        "ThresholdMessageHelpers - error - Value should be less than 'Minimum amount' value error message for threshold validation",
                                    _tags: "frontend,brand,admin,promotions,eligibility_rules,threshold_message,helpers",
                                    _key: "brand.admin.promotions.eligibility_rules.threshold_message.helpers.value_less_than_minimum_amount_message",
                                },
                            ),
                            value_less_than_minimum_quantity_message: tx.t(
                                "Value should be less than 'Minimum quantity' value",
                                {
                                    _context:
                                        "ThresholdMessageHelpers - error - Value should be less than 'Minimum quantity' value error message for threshold validation",
                                    _tags: "frontend,brand,admin,promotions,eligibility_rules,threshold_message,helpers",
                                    _key: "brand.admin.promotions.eligibility_rules.threshold_message.helpers.value_less_than_minimum_quantity_message",
                                },
                            ),
                        },
                        fields: {
                            order_quantity_label: tx.t("If order quantity is greater than:", {
                                _context:
                                    "ThresholdMessageFields - label - If order quantity is greater than label for threshold rule",
                                _tags: "frontend,brand,admin,promotions,eligibility_rules,threshold_message,fields",
                                _key: "brand.admin.promotions.eligibility_rules.threshold_message.fields.order_quantity_label",
                            }),
                            order_amount_label: tx.t("If order amount is greater than:", {
                                _context:
                                    "ThresholdMessageFields - label - If order amount is greater than label for threshold rule",
                                _tags: "frontend,brand,admin,promotions,eligibility_rules,threshold_message,fields",
                                _key: "brand.admin.promotions.eligibility_rules.threshold_message.fields.order_amount_label",
                            }),
                            item_quantity_label: tx.t("If item quantity is greater than:", {
                                _context:
                                    "ThresholdMessageFields - label - If item quantity is greater than label for threshold rule",
                                _tags: "frontend,brand,admin,promotions,eligibility_rules,threshold_message,fields",
                                _key: "brand.admin.promotions.eligibility_rules.threshold_message.fields.item_quantity_label",
                            }),
                            item_amount_label: tx.t("If item amount is greater than:", {
                                _context:
                                    "ThresholdMessageFields - label - If item amount is greater than label for threshold rule",
                                _tags: "frontend,brand,admin,promotions,eligibility_rules,threshold_message,fields",
                                _key: "brand.admin.promotions.eligibility_rules.threshold_message.fields.item_amount_label",
                            }),
                        },
                        include_threshold_messaging_label: tx.t("Include threshold messaging", {
                            _context:
                                "ThresholdMessage - label - Include threshold messaging label for threshold message component",
                            _tags: "frontend,brand,admin,promotions,eligibility_rules,threshold_message",
                            _key: "brand.admin.promotions.eligibility_rules.threshold_message.include_threshold_messaging_label",
                        }),
                        discount_close_to_eligibility_message: tx.t(
                            "A message will be displayed when a discount is close to meeting eligibility",
                            {
                                _context:
                                    "ThresholdMessage - info - Message displayed when discount is close to meeting eligibility in threshold message component",
                                _tags: "frontend,brand,admin,promotions,eligibility_rules,threshold_message",
                                _key: "brand.admin.promotions.eligibility_rules.threshold_message.discount_close_to_eligibility_message",
                            },
                        ),
                    },
                    conditional_date_range_rule: {
                        start_date_label: tx.t("Start date", {
                            _context:
                                "ConditionalDateRangeRule - label - Start date field label for conditional date range rule",
                            _tags: "frontend,brand,admin,promotions,eligibility_rules,conditional_date_range_rule",
                            _key: "brand.admin.promotions.eligibility_rules.conditional_date_range_rule.start_date_label",
                        }),
                        end_date_label: tx.t("End date", {
                            _context:
                                "ConditionalDateRangeRule - label - End date field label for conditional date range rule",
                            _tags: "frontend,brand,admin,promotions,eligibility_rules,conditional_date_range_rule",
                            _key: "brand.admin.promotions.eligibility_rules.conditional_date_range_rule.end_date_label",
                        }),
                        select_date_range_hint: tx.t("Select date range", {
                            _context:
                                "ConditionalDateRangeRule - hint - Hint text for selecting date range in conditional date range rule",
                            _tags: "frontend,brand,admin,promotions,eligibility_rules,conditional_date_range_rule",
                            _key: "brand.admin.promotions.eligibility_rules.conditional_date_range_rule.select_date_range_hint",
                        }),
                    },
                    no_fields_chosen_message: tx.t("You should select at least 1 option", {
                        _context:
                            "Eligibility Rules - error - You should select at least 1 option error message for rule validation",
                        _tags: "frontend,brand,admin,promotions,eligibility_rules",
                        _key: "brand.admin.promotions.eligibility_rules.no_fields_chosen_message",
                    }),
                    order_quantity_label: tx.t("Order quantity", {
                        _context: "Eligibility Rules - Order quantity - Option label for rule type selector",
                        _tags: "frontend,brand,admin,promotions,eligibility_rules",
                        _key: "brand.admin.promotions.eligibility_rules.order_quantity_label",
                    }),
                    order_amount_total_label: tx.t("Order amount total", {
                        _context: "Eligibility Rules - Order amount total - Option label for rule type selector",
                        _tags: "frontend,brand,admin,promotions,eligibility_rules",
                        _key: "brand.admin.promotions.eligibility_rules.order_amount_total_label",
                    }),
                    order_level_field_label: tx.t("Order level field", {
                        _context: "Eligibility Rules - Order level field - Option label for rule type selector",
                        _tags: "frontend,brand,admin,promotions,eligibility_rules",
                        _key: "brand.admin.promotions.eligibility_rules.order_level_field_label",
                    }),
                    order_delivery_date_label: tx.t("Order delivery date", {
                        _context: "Eligibility Rules - Order delivery date - Option label for rule type selector",
                        _tags: "frontend,brand,admin,promotions,eligibility_rules",
                        _key: "brand.admin.promotions.eligibility_rules.order_delivery_date_label",
                    }),
                    conditional_date_range_label: tx.t("Conditional date range", {
                        _context: "Eligibility Rules - Conditional date range - Option label for rule type selector",
                        _tags: "frontend,brand,admin,promotions,eligibility_rules",
                        _key: "brand.admin.promotions.eligibility_rules.conditional_date_range_label",
                    }),
                    shipped_amount_label: tx.t("Shipped amount", {
                        _context: "Eligibility Rules - Shipped amount - Option label for rule type selector",
                        _tags: "frontend,brand,admin,promotions,eligibility_rules",
                        _key: "brand.admin.promotions.eligibility_rules.shipped_amount_label",
                    }),
                    conditional_message_part: tx.t(
                        "Pair Conditional date range with either Order amount total or Shipped amount",
                        {
                            _context: "Eligibility Rules - Conditional date range - Pairing message part",
                            _tags: "frontend,brand,admin,promotions,eligibility_rules",
                            _key: "brand.admin.promotions.eligibility_rules.conditional_message_part",
                        },
                    ),
                    conditional_message_full: tx.t(
                        "{orderMessagePart}. When paired, promotion eligibility is based on past orders within the provided date range, not the current Working Order.",
                        {
                            _context: "Eligibility Rules - Conditional date range - Full pairing message",
                            _tags: "frontend,brand,admin,promotions,eligibility_rules",
                            _key: "brand.admin.promotions.eligibility_rules.conditional_message_full",
                        },
                    ),
                    rule_type_label: tx.t("Rule type", {
                        _context: "Eligibility Rules - Rule type label - Dropdown label for rule type selector",
                        _tags: "frontend,brand,admin,promotions,eligibility_rules",
                        _key: "brand.admin.promotions.eligibility_rules.rule_type_label",
                    }),
                    order_delivery_date_rule: {
                        start_date_label: tx.t("Start date", {
                            _context:
                                "OrderDeliveryDateRule - label - Start date field label for order delivery date rule",
                            _tags: "frontend,brand,admin,promotions,eligibility_rules,order_delivery_date_rule",
                            _key: "brand.admin.promotions.eligibility_rules.order_delivery_date_rule.start_date_label",
                        }),
                        select_date_range_hint: tx.t("Select date range", {
                            _context:
                                "OrderDeliveryDateRule - hint - Hint text for selecting date range in order delivery date rule",
                            _tags: "frontend,brand,admin,promotions,eligibility_rules,order_delivery_date_rule",
                            _key: "brand.admin.promotions.eligibility_rules.order_delivery_date_rule.select_date_range_hint",
                        }),
                        end_date_label: tx.t("End date", {
                            _context:
                                "OrderDeliveryDateRule - label - End date field label for order delivery date rule",
                            _tags: "frontend,brand,admin,promotions,eligibility_rules,order_delivery_date_rule",
                            _key: "brand.admin.promotions.eligibility_rules.order_delivery_date_rule.end_date_label",
                        }),
                    },
                    order_level_fields_rule: {
                        field_label: tx.t("Field", {
                            _context: "OrderLevelFieldsRule - label - Field selector label for order level fields rule",
                            _tags: "frontend,brand,admin,promotions,eligibility_rules,order_level_fields_rule",
                            _key: "brand.admin.promotions.eligibility_rules.order_level_fields_rule.field_label",
                        }),
                        value_label: tx.t("Value", {
                            _context: "OrderLevelFieldsRule - label - Value lookup label for order level fields rule",
                            _tags: "frontend,brand,admin,promotions,eligibility_rules,order_level_fields_rule",
                            _key: "brand.admin.promotions.eligibility_rules.order_level_fields_rule.value_label",
                        }),
                    },
                },
                product_total: {
                    item_quantity: tx.t("Item quantity", {
                        _context: "ProductTotal - select option - item quantity option for product total rule",
                        _tags: "frontend,brand,admin,promotions,product_total",
                        _key: "brand.admin.promotions.product_total.item_quantity",
                    }),
                    item_amount: tx.t("Item amount", {
                        _context: "ProductTotal - select option - item amount option for product total rule",
                        _tags: "frontend,brand,admin,promotions,product_total",
                        _key: "brand.admin.promotions.product_total.item_amount",
                    }),
                    set_minimum_rules: tx.t("Set minimum rules", {
                        _context: "ProductTotal - checkbox label - set minimum rules for product total eligibility",
                        _tags: "frontend,brand,admin,promotions,product_total",
                        _key: "brand.admin.promotions.product_total.set_minimum_rules",
                    }),
                    item_filter_label: tx.t("Item filter:", {
                        _context: "ProductTotal - select label - item filter label for product total rule",
                        _tags: "frontend,brand,admin,promotions,product_total",
                        _key: "brand.admin.promotions.product_total.item_filter_label",
                    }),
                },
                discount_applied: {
                    percentage_off: tx.t("Percentage off", {
                        _context: "DiscountApplied - option label - percentage off product discount",
                        _tags: "frontend,brand,admin,promotions,discount_applied",
                        _key: "brand.admin.promotions.discount_applied.percentage_off",
                    }),
                    amount_off: tx.t("Amount off", {
                        _context: "DiscountApplied - option label - amount off order discount",
                        _tags: "frontend,brand,admin,promotions,discount_applied",
                        _key: "brand.admin.promotions.discount_applied.amount_off",
                    }),
                    free_shipping: tx.t("Free shipping", {
                        _context: "DiscountApplied - option label - free shipping order discount",
                        _tags: "frontend,brand,admin,promotions,discount_applied",
                        _key: "brand.admin.promotions.discount_applied.free_shipping",
                    }),
                    net_terms_extension: tx.t("Net terms extension", {
                        _context: "DiscountApplied - option label - net terms extension order discount",
                        _tags: "frontend,brand,admin,promotions,discount_applied",
                        _key: "brand.admin.promotions.discount_applied.net_terms_extension",
                    }),
                    amount_off_each_item: tx.t("Amount off each item", {
                        _context: "DiscountApplied - option label - amount off each item product discount",
                        _tags: "frontend,brand,admin,promotions,discount_applied",
                        _key: "brand.admin.promotions.discount_applied.amount_off_each_item",
                    }),
                    discount_must_be_greater_than_zero_error: tx.t("Discount must be greater than 0", {
                        _context: "Promotions Discount Applied - error - discount must be greater than 0",
                        _tags: "frontend,brand,admin,promotions,discount_applied",
                        _key: "brand.admin.promotions.discount_applied.discount_must_be_greater_than_zero_error",
                    }),
                    net_terms_must_be_greater_than_zero_error: tx.t("Net terms extension must be greater than 0", {
                        _context: "Promotions Discount Applied - error - net terms extension must be greater than 0",
                        _tags: "frontend,brand,admin,promotions,discount_applied",
                        _key: "brand.admin.promotions.discount_applied.net_terms_must_be_greater_than_zero_error",
                    }),
                    net_terms_must_be_integer_error: tx.t("Net terms extension must be an integer", {
                        _context: "Promotions Discount Applied - error - net terms extension must be an integer",
                        _tags: "frontend,brand,admin,promotions,discount_applied",
                        _key: "brand.admin.promotions.discount_applied.net_terms_must_be_integer_error",
                    }),
                    discount_must_be_less_than_100_percent_error: tx.t("Discount must be less than 100%", {
                        _context: "Promotions Discount Applied - error - discount must be less than 100%",
                        _tags: "frontend,brand,admin,promotions,discount_applied",
                        _key: "brand.admin.promotions.discount_applied.discount_must_be_less_than_100_percent_error",
                    }),
                    total_days_to_submit_payment_label: tx.t("Total days to submit payment", {
                        _context: "Promotions Discount Applied - input label - total days to submit payment",
                        _tags: "frontend,brand,admin,promotions,discount_applied",
                        _key: "brand.admin.promotions.discount_applied.total_days_to_submit_payment_label",
                    }),
                    discount_value_label: tx.t("Discount value", {
                        _context: "Promotions Discount Applied - input label - discount value",
                        _tags: "frontend,brand,admin,promotions,discount_applied",
                        _key: "brand.admin.promotions.discount_applied.discount_value_label",
                    }),
                    enter_value_placeholder: tx.t("Enter value", {
                        _context: "Promotions Discount Applied - input placeholder - enter value",
                        _tags: "frontend,brand,admin,promotions,discount_applied",
                        _key: "brand.admin.promotions.discount_applied.enter_value_placeholder",
                    }),
                    reward_type_label: tx.t("Reward type", {
                        _context: "Promotions Discount Applied - select label - reward type",
                        _tags: "frontend,brand,admin,promotions,discount_applied",
                        _key: "brand.admin.promotions.discount_applied.reward_type_label",
                    }),
                    add_discount_button: tx.t("Add discount", {
                        _context: "Promotions Discount Applied - button label - add discount",
                        _tags: "frontend,brand,admin,promotions,discount_applied",
                        _key: "brand.admin.promotions.discount_applied.add_discount_button",
                    }),
                },
                header: {
                    cancel_button: tx.t("Cancel", {
                        _context: "Promotion Header - button label - cancel",
                        _tags: "frontend,brand,admin,promotions,header",
                        _key: "brand.admin.promotions.header.cancel_button",
                    }),
                    save_button: tx.t("Save", {
                        _context: "Promotion Header - button label - save",
                        _tags: "frontend,brand,admin,promotions,header",
                        _key: "brand.admin.promotions.header.save_button",
                    }),
                    create_button: tx.t("Create", {
                        _context: "Promotion Header - button label - create",
                        _tags: "frontend,brand,admin,promotions,header",
                        _key: "brand.admin.promotions.header.create_button",
                    }),
                    duplicate_menu_item: tx.t("Duplicate", {
                        _context: "Promotion Header - menu item - duplicate",
                        _tags: "frontend,brand,admin,promotions,header",
                        _key: "brand.admin.promotions.header.duplicate_menu_item",
                    }),
                    delete_menu_item: tx.t("Delete", {
                        _context: "Promotion Header - menu item - delete",
                        _tags: "frontend,brand,admin,promotions,header",
                        _key: "brand.admin.promotions.header.delete_menu_item",
                    }),
                },
                name: {
                    name_is_taken_error: tx.t("This name is taken", {
                        _context: "Promotion Name - error - this name is taken",
                        _tags: "frontend,brand,admin,promotions,name",
                        _key: "brand.admin.promotions.name.name_is_taken_error",
                    }),
                    promotion_name_label: tx.t("Promotion name", {
                        _context: "Promotion Name - input label - promotion name",
                        _tags: "frontend,brand,admin,promotions,name",
                        _key: "brand.admin.promotions.name.promotion_name_label",
                    }),
                    enter_name_placeholder: tx.t("Enter name", {
                        _context: "Promotion Name - input placeholder - enter name",
                        _tags: "frontend,brand,admin,promotions,name",
                        _key: "brand.admin.promotions.name.enter_name_placeholder",
                    }),
                    promotion_name_description: tx.t("This name will be shown to customers.", {
                        _context: "Promotion Name - input description - this name will be shown to customers",
                        _tags: "frontend,brand,admin,promotions,name",
                        _key: "brand.admin.promotions.name.promotion_name_description",
                    }),
                    description_label: tx.t("Description", {
                        _context: "Promotion Name - input label - description",
                        _tags: "frontend,brand,admin,promotions,name",
                        _key: "brand.admin.promotions.name.description_label",
                    }),
                    description_description: tx.t(
                        "Describe your promotion and indicate the value and spend requirements.",
                        {
                            _context:
                                "Promotion Name - input description - describe your promotion and indicate the value and spend requirements",
                            _tags: "frontend,brand,admin,promotions,name",
                            _key: "brand.admin.promotions.name.description_description",
                        },
                    ),
                    active_label: tx.t("Active", {
                        _context: "Promotion Name - switch label - active",
                        _tags: "frontend,brand,admin,promotions,name",
                        _key: "brand.admin.promotions.name.active_label",
                    }),
                },
                select_customers: {
                    select_at_least_one_group_error: tx.t("Select at least 1 group", {
                        _context: "Select Customers - error - select at least 1 group",
                        _tags: "frontend,brand,admin,promotions,select_customers",
                        _key: "brand.admin.promotions.select_customers.select_at_least_one_group_error",
                    }),
                    company_name_not_selected_error: tx.t("Company name not selected", {
                        _context: "Select Customers - error - company name not selected",
                        _tags: "frontend,brand,admin,promotions,select_customers",
                        _key: "brand.admin.promotions.select_customers.company_name_not_selected_error",
                    }),
                },
                delete_confirmation_modal: {
                    delete_selected_promotions: tx.t("Would you like to delete selected promotions?", {
                        _context: "DeleteConfirmationModal - dialog text - bulk delete selected promotions",
                        _tags: "frontend,brand,admin,promotions,delete_confirmation_modal",
                        _key: "brand.admin.promotions.delete_confirmation_modal.delete_selected_promotions",
                    }),
                    delete_one_selected_promotion: tx.t("Would you like to delete this promotion entirely?", {
                        _context: "DeleteConfirmationModal - dialog text - delete one selected promotion",
                        _tags: "frontend,brand,admin,promotions,delete_confirmation_modal",
                        _key: "brand.admin.promotions.delete_confirmation_modal.delete_one_selected_promotion",
                    }),
                    promotions_will_be_deleted: tx.t("Promotions will be deleted", {
                        _context: "DeleteConfirmationModal - dialog title - bulk promotions will be deleted",
                        _tags: "frontend,brand,admin,promotions,delete_confirmation_modal",
                        _key: "brand.admin.promotions.delete_confirmation_modal.promotions_will_be_deleted",
                    }),
                    one_promotion_will_be_deleted: tx.t("Promotion will be deleted", {
                        _context: "DeleteConfirmationModal - dialog title - one promotion will be deleted",
                        _tags: "frontend,brand,admin,promotions,delete_confirmation_modal",
                        _key: "brand.admin.promotions.delete_confirmation_modal.one_promotion_will_be_deleted",
                    }),
                    delete_promotions_confirmation: tx.t("Yes, Delete Promotions", {
                        _context: "DeleteConfirmationModal - confirm button - bulk delete promotions",
                        _tags: "frontend,brand,admin,promotions,delete_confirmation_modal",
                        _key: "brand.admin.promotions.delete_confirmation_modal.delete_promotions_confirmation",
                    }),
                    delete_one_promotion_confirmation: tx.t("Yes, Delete Promotion", {
                        _context: "DeleteConfirmationModal - confirm button - delete one promotion",
                        _tags: "frontend,brand,admin,promotions,delete_confirmation_modal",
                        _key: "brand.admin.promotions.delete_confirmation_modal.delete_one_promotion_confirmation",
                    }),
                    cancel: tx.t("Cancel", {
                        _context: "DeleteConfirmationModal - cancel button - cancel action",
                        _tags: "frontend,brand,admin,promotions,delete_confirmation_modal",
                        _key: "brand.admin.promotions.delete_confirmation_modal.cancel",
                    }),
                    are_you_sure_proceed: tx.t("Are you sure you want to proceed?", {
                        _context: "DeleteConfirmationModal - dialog text - are you sure you want to proceed",
                        _tags: "frontend,brand,admin,promotions,delete_confirmation_modal",
                        _key: "brand.admin.promotions.delete_confirmation_modal.are_you_sure_proceed",
                    }),
                },
                duplicate_modal: {
                    name_is_taken_error: tx.t("This name is taken", {
                        _context: "DuplicateModal - error - name is taken",
                        _tags: "frontend,brand,admin,promotions,duplicate_modal",
                        _key: "brand.admin.promotions.duplicate_modal.name_is_taken_error",
                    }),
                    cannot_create_with_same_name_error: tx.t("We can not create promotion with the same name", {
                        _context: "DuplicateModal - error - cannot create promotion with same name",
                        _tags: "frontend,brand,admin,promotions,duplicate_modal",
                        _key: "brand.admin.promotions.duplicate_modal.cannot_create_with_same_name_error",
                    }),
                    success_message: tx.t("Promotion successfully duplicated", {
                        _context: "DuplicateModal - snackbar - promotion successfully duplicated",
                        _tags: "frontend,brand,admin,promotions,duplicate_modal",
                        _key: "brand.admin.promotions.duplicate_modal.success_message",
                    }),
                    error_message: tx.t("Error duplicate promotion. Try again later", {
                        _context: "DuplicateModal - snackbar - error duplicate promotion",
                        _tags: "frontend,brand,admin,promotions,duplicate_modal",
                        _key: "brand.admin.promotions.duplicate_modal.error_message",
                    }),
                    title: tx.t("Duplicate", {
                        _context: "DuplicateModal - dialog title - duplicate promotion",
                        _tags: "frontend,brand,admin,promotions,duplicate_modal",
                        _key: "brand.admin.promotions.duplicate_modal.title",
                    }),
                    cancel: tx.t("Cancel", {
                        _context: "DuplicateModal - cancel button label",
                        _tags: "frontend,brand,admin,promotions,duplicate_modal",
                        _key: "brand.admin.promotions.duplicate_modal.cancel",
                    }),
                    save: tx.t("Save", {
                        _context: "DuplicateModal - save button label",
                        _tags: "frontend,brand,admin,promotions,duplicate_modal",
                        _key: "brand.admin.promotions.duplicate_modal.save",
                    }),
                    promotion_name_label: tx.t("Promotion name", {
                        _context: "DuplicateModal - label - promotion name",
                        _tags: "frontend,brand,admin,promotions,duplicate_modal",
                        _key: "brand.admin.promotions.duplicate_modal.promotion_name_label",
                    }),
                    enter_name_placeholder: tx.t("Enter name", {
                        _context: "DuplicateModal - placeholder - enter name",
                        _tags: "frontend,brand,admin,promotions,duplicate_modal",
                        _key: "brand.admin.promotions.duplicate_modal.enter_name_placeholder",
                    }),
                },
                product_eligibility_rules: {
                    product_availability_label: tx.t("Product availability", {
                        _context: "ProductAvailabilityRule - label - product availability",
                        _tags: "frontend,brand,admin,promotions,product_eligibility_rules",
                        _key: "brand.admin.promotions.product_eligibility_rules.product_availability_label",
                    }),
                    product_filter_label: tx.t("Product filter:", {
                        _context: "ProductEligibilityRules - label - product filter",
                        _tags: "frontend,brand,admin,promotions,product_eligibility_rules",
                        _key: "brand.admin.promotions.product_eligibility_rules.product_filter_label",
                    }),
                    prebook_label: tx.t("Prebook", {
                        _context: "ProductAvailabilityRule - option - Prebook",
                        _tags: "frontend,brand,admin,promotions,product_eligibility_rules",
                        _key: "brand.admin.promotions.product_eligibility_rules.prebook_label",
                    }),
                    ats_label: tx.t("ATS", {
                        _context: "ProductAvailabilityRule - option - ATS",
                        _tags: "frontend,brand,admin,promotions,product_eligibility_rules",
                        _key: "brand.admin.promotions.product_eligibility_rules.ats_label",
                    }),
                },
                list: {
                    breadcrumbs: {
                        brand_admin: tx.t("Brand Admin", {
                            _context: "PromotionsList - breadcrumbs - Brand Admin",
                            _tags: "frontend,brand,admin,promotions,list,breadcrumbs",
                            _key: "brand.admin.promotions.list.breadcrumbs.brand_admin",
                        }),
                        promotions: tx.t("Promotions", {
                            _context: "PromotionsList - breadcrumbs - Promotions",
                            _tags: "frontend,brand,admin,promotions,list,breadcrumbs",
                            _key: "brand.admin.promotions.list.breadcrumbs.promotions",
                        }),
                        list: tx.t("List", {
                            _context: "PromotionsList - breadcrumbs - List",
                            _tags: "frontend,brand,admin,promotions,list,breadcrumbs",
                            _key: "brand.admin.promotions.list.breadcrumbs.list",
                        }),
                    },
                    order_promotion_label: tx.t("Order promotion", {
                        _context: "Promotions List - type label - order promotion",
                        _tags: "frontend,brand,admin,promotions,list",
                        _key: "brand.admin.promotions.list.order_promotion_label",
                    }),
                    order_promotion_desc: tx.t("Set order criteria for promotion eligibility", {
                        _context: "Promotions List - type description - set order criteria for promotion eligibility",
                        _tags: "frontend,brand,admin,promotions,list",
                        _key: "brand.admin.promotions.list.order_promotion_desc",
                    }),
                    product_promotion_label: tx.t("Product promotion", {
                        _context: "Promotions List - type label - product promotion",
                        _tags: "frontend,brand,admin,promotions,list",
                        _key: "brand.admin.promotions.list.product_promotion_label",
                    }),
                    product_promotion_desc: tx.t("Set product criteria for promotion eligibility", {
                        _context: "Promotions List - type description - set product criteria for promotion eligibility",
                        _tags: "frontend,brand,admin,promotions,list",
                        _key: "brand.admin.promotions.list.product_promotion_desc",
                    }),
                    create_promotion_label: tx.t("Create Promotion", {
                        _context: "Promotions List - button label - create new promotion",
                        _tags: "frontend,brand,admin,promotions,list",
                        _key: "brand.admin.promotions.list.create_promotion_label",
                    }),
                    edit_action_label: tx.t("Edit", {
                        _context: "Promotions List - action label - edit promotion",
                        _tags: "frontend,brand,admin,promotions,list",
                        _key: "brand.admin.promotions.list.edit_action_label",
                    }),
                    duplicate_action_label: tx.t("Duplicate", {
                        _context: "Promotions List - action label - duplicate promotion",
                        _tags: "frontend,brand,admin,promotions,list",
                        _key: "brand.admin.promotions.list.duplicate_action_label",
                    }),
                    delete_action_label: tx.t("Delete", {
                        _context: "Promotions List - action label - delete promotion",
                        _tags: "frontend,brand,admin,promotions,list",
                        _key: "brand.admin.promotions.list.delete_action_label",
                    }),
                    activate_action_label: tx.t("Activate", {
                        _context: "Promotions List - action label - activate promotion",
                        _tags: "frontend,brand,admin,promotions,list",
                        _key: "brand.admin.promotions.list.activate_action_label",
                    }),
                    deactivate_action_label: tx.t("Deactivate", {
                        _context: "Promotions List - action label - deactivate promotion",
                        _tags: "frontend,brand,admin,promotions,list",
                        _key: "brand.admin.promotions.list.deactivate_action_label",
                    }),
                    page_title: tx.t("Manage Promotions", {
                        _context: "Promotions List - page title - manage promotions",
                        _tags: "frontend,brand,admin,promotions,list",
                        _key: "brand.admin.promotions.list.page_title",
                    }),
                    grid: {
                        type_product_label: tx.t("Product", {
                            _context: "Promotions List Grid - filter label - product type",
                            _tags: "frontend,brand,admin,promotions,list,grid",
                            _key: "brand.admin.promotions.list.grid.type_product_label",
                        }),
                        type_order_label: tx.t("Order", {
                            _context: "Promotions List Grid - filter label - order type",
                            _tags: "frontend,brand,admin,promotions,list,grid",
                            _key: "brand.admin.promotions.list.grid.type_order_label",
                        }),
                        status_active_label: tx.t("Active", {
                            _context: "Promotions List Grid - filter label - active status",
                            _tags: "frontend,brand,admin,promotions,list,grid",
                            _key: "brand.admin.promotions.list.grid.status_active_label",
                        }),
                        status_inactive_label: tx.t("Inactive", {
                            _context: "Promotions List Grid - filter label - inactive status",
                            _tags: "frontend,brand,admin,promotions,list,grid",
                            _key: "brand.admin.promotions.list.grid.status_inactive_label",
                        }),
                        date_range_from_label: tx.t("From", {
                            _context: "Promotions List Grid - filter label - date range from",
                            _tags: "frontend,brand,admin,promotions,list,grid",
                            _key: "brand.admin.promotions.list.grid.date_range_from_label",
                        }),
                        date_range_to_label: tx.t("To", {
                            _context: "Promotions List Grid - filter label - date range to",
                            _tags: "frontend,brand,admin,promotions,list,grid",
                            _key: "brand.admin.promotions.list.grid.date_range_to_label",
                        }),
                        date_range_ok_label: tx.t("Ok", {
                            _context: "Promotions List Grid - filter label - date range ok button",
                            _tags: "frontend,brand,admin,promotions,list,grid",
                            _key: "brand.admin.promotions.list.grid.date_range_ok_label",
                        }),
                        no_results_label: tx.t("No results found", {
                            _context: "Promotions List Grid - filter label - no results found",
                            _tags: "frontend,brand,admin,promotions,list,grid",
                            _key: "brand.admin.promotions.list.grid.no_results_label",
                        }),
                        clear_label: tx.t("Clear", {
                            _context: "Promotions List Grid - filter label - clear button",
                            _tags: "frontend,brand,admin,promotions,list,grid",
                            _key: "brand.admin.promotions.list.grid.clear_label",
                        }),
                    },
                },
                page: {
                    page_title: tx.t("{action} {type} promotion", {
                        _context: "Promotions admin page - title - create or edit a promotion title",
                        _tags: "frontend,brand,admin,promotions,page",
                        _key: "brand.admin.promotions.page.page_title",
                    }),
                    page_subtitle: tx.t("{action} {type} criteria for promotion eligibility.", {
                        _context: "Promotions admin page - subtitle - create or edit promotion eligibility criteria",
                        _tags: "frontend,brand,admin,promotions,page",
                        _key: "brand.admin.promotions.page.page_subtitle",
                    }),
                    name_title: tx.t("Promotion name", {
                        _context: "Promotions admin page - section title - promotion name",
                        _tags: "frontend,brand,admin,promotions,page",
                        _key: "brand.admin.promotions.page.name_title",
                    }),
                    name_subtitle: tx.t(
                        "Create a unique name for your promotion, and a detailed description for your customers.",
                        {
                            _context: "Promotions admin page - section subtitle - promotion name description",
                            _tags: "frontend,brand,admin,promotions,page",
                            _key: "brand.admin.promotions.page.name_subtitle",
                        },
                    ),
                    audience_title: tx.t("Audience", {
                        _context: "Promotions admin page - section title - audience",
                        _tags: "frontend,brand,admin,promotions,page",
                        _key: "brand.admin.promotions.page.audience_title",
                    }),
                    audience_subtitle: tx.t("Select the promotion’s target customer and currency.", {
                        _context: "Promotions admin page - section subtitle - audience description",
                        _tags: "frontend,brand,admin,promotions,page",
                        _key: "brand.admin.promotions.page.audience_subtitle",
                    }),
                    target_customer_label: tx.t("Target customer", {
                        _context: "Promotions admin page - label - target customer",
                        _tags: "frontend,brand,admin,promotions,page",
                        _key: "brand.admin.promotions.page.target_customer_label",
                    }),
                    combinations_title: tx.t("Promotion combinations", {
                        _context: "Promotions admin page - section title - promotion combinations",
                        _tags: "frontend,brand,admin,promotions,page",
                        _key: "brand.admin.promotions.page.combinations_title",
                    }),
                    combinations_subtitle: tx.t(
                        "Select the offer type(s) to combine with this promotion. If none are selected, and an order qualifies for more than one, then we’ll apply the discount offering the greatest savings.",
                        {
                            _context: "Promotions admin page - section subtitle - promotion combinations description",
                            _tags: "frontend,brand,admin,promotions,page",
                            _key: "brand.admin.promotions.page.combinations_subtitle",
                        },
                    ),
                    eligibility_title: tx.t("Eligibility rules", {
                        _context: "Promotions admin page - section title - eligibility rules",
                        _tags: "frontend,brand,admin,promotions,page",
                        _key: "brand.admin.promotions.page.eligibility_title",
                    }),
                    eligibility_subtitle: tx.t("Specify the criteria needed to qualify for the promotion.", {
                        _context: "Promotions admin page - section subtitle - eligibility rules description",
                        _tags: "frontend,brand,admin,promotions,page",
                        _key: "brand.admin.promotions.page.eligibility_subtitle",
                    }),
                    reward_title: tx.t("Reward applied", {
                        _context: "Promotions admin page - section title - reward applied",
                        _tags: "frontend,brand,admin,promotions,page",
                        _key: "brand.admin.promotions.page.reward_title",
                    }),
                    reward_subtitle: tx.t("Choose the earned reward for qualifying for the promotion.", {
                        _context: "Promotions admin page - section subtitle - reward applied description",
                        _tags: "frontend,brand,admin,promotions,page",
                        _key: "brand.admin.promotions.page.reward_subtitle",
                    }),
                    active_dates_title: tx.t("Active dates", {
                        _context: "Promotions admin page - section title - active dates",
                        _tags: "frontend,brand,admin,promotions,page",
                        _key: "brand.admin.promotions.page.active_dates_title",
                    }),
                    active_dates_subtitle: tx.t(
                        "Define the time frame that you would like the promotion to run. The time corresponds to your local time zone.",
                        {
                            _context: "Promotions admin page - section subtitle - active dates description",
                            _tags: "frontend,brand,admin,promotions,page",
                            _key: "brand.admin.promotions.page.active_dates_subtitle",
                        },
                    ),
                },
            },
            imagery: {
                title: tx.t("Imagery & media", {
                    _context: "Brand admin menu - Subsection title - Admin page menu Imagery & Media submenu",
                    _tags: "frontend,brand,admin,imagery",
                    _key: "brand.admin.imagery.title",
                }),
                dropbox_management_label: tx.t("Dropbox management", {
                    _context:
                        "Brand admin Imagery & Media menu - subsection label - redirects to Dropbox Management configuration and settings",
                    _tags: "frontend,brand,admin,imagery",
                    _key: "brand.admin.imagery.dropbox_management_label",
                }),
                dropbox_management_unlimited_images_desc: tx.t(
                    "Import your product images and videos directly from Dropbox.",
                    {
                        _context:
                            "Brand admin Imagery & Media menu - subsection description - redirects to Dropbox Management configuration and settings",
                        _tags: "frontend,brand,admin,imagery",
                        _key: "brand.admin.imagery.dropbox_management_unlimited_images_desc",
                    },
                ),
                dropbox_management_desc: tx.t("Import your product images directly from Dropbox.", {
                    _context:
                        "Brand admin Imagery & Media menu - subsection description - redirects to Dropbox Management configuration and settings",
                    _tags: "frontend,brand,admin,imagery",
                    _key: "brand.admin.imagery.dropbox_management_desc",
                }),
                image_management_label: tx.t("Image management", {
                    _context:
                        "Brand admin Imagery & Media menu - subsection label - redirects to Image Management configuration and settings",
                    _tags: "frontend,brand,admin,imagery",
                    _key: "brand.admin.imagery.image_management_label",
                }),
                image_management_desc: tx.t("Assign images to products.", {
                    _context:
                        "Brand admin Imagery & Media menu - subsection description - redirects to Image Management configuration and settings",
                    _tags: "frontend,brand,admin,imagery",
                    _key: "brand.admin.imagery.image_management_desc",
                }),
                email_image_management_label: tx.t("Email header image management", {
                    _context:
                        "Brand admin Imagery & Media menu - subsection label - redirects to Email Header Image Management configuration and settings",
                    _tags: "frontend,brand,admin,imagery",
                    _key: "brand.admin.imagery.email_image_management_label",
                }),
                email_image_management_desc: tx.t("Upload custom email header image.", {
                    _context:
                        "Brand admin Imagery & Media menu - subsection description - redirects to Email Header Image Management configuration and settings",
                    _tags: "frontend,brand,admin,imagery",
                    _key: "brand.admin.imagery.email_image_management_desc",
                }),
                image_reports_label: tx.t("Image reports", {
                    _context:
                        "Brand admin Imagery & Media menu - subsection label - redirects to Image Reports configuration and settings",
                    _tags: "frontend,brand,admin,imagery",
                    _key: "brand.admin.imagery.image_reports_label",
                }),
                image_reports_desc: tx.t("Download image reports.", {
                    _context:
                        "Brand admin Imagery & Media menu - subsection description - redirects to Image Reports configuration and settings",
                    _tags: "frontend,brand,admin,imagery",
                    _key: "brand.admin.imagery.image_reports_desc",
                }),
                image_settings_label: tx.t("Image settings", {
                    _context:
                        "Brand admin Imagery & Media menu - subsection label - redirects to Image Settings configuration and settings",
                    _tags: "frontend,brand,admin,imagery",
                    _key: "brand.admin.imagery.image_settings_label",
                }),
                image_settings_desc: tx.t("Set up and manage image and media naming convention.", {
                    _context:
                        "Brand admin Imagery & Media menu - subsection description - redirects to Image Settings configuration and settings",
                    _tags: "frontend,brand,admin,imagery",
                    _key: "brand.admin.imagery.image_settings_desc",
                }),
                image_settings_unlimited_images_desc: tx.t("Set up and manage image and media naming conventions.", {
                    _context:
                        "Brand admin Imagery & Media menu - subsection description - redirects to Image Settings configuration and settings for brand with unlimited_images brand preference",
                    _tags: "frontend,brand,admin,imagery",
                    _key: "brand.admin.imagery.image_settings_unlimited_images_desc",
                }),
                product_images_label: tx.t("Product images", {
                    _context:
                        "Brand admin Imagery & Media menu - subsection label - redirects to Product Images configuration and settings",
                    _tags: "frontend,brand,admin,imagery",
                    _key: "brand.admin.imagery.product_images_label",
                }),
                product_images_desc: tx.t("Upload product images.", {
                    _context:
                        "Brand admin Imagery & Media menu - subsection description - redirects to Product Images configuration and settings",
                    _tags: "frontend,brand,admin,imagery",
                    _key: "brand.admin.imagery.product_images_desc",
                }),
                media_management_label: tx.t("Media management", {
                    _context:
                        "Brand admin Imagery & Media menu - subsection label - redirects to Media Management configuration and settings",
                    _tags: "frontend,brand,admin,imagery",
                    _key: "brand.admin.imagery.media_management_label",
                }),
                media_management_desc: tx.t("Manage image galleries, press and video assets.", {
                    _context:
                        "Brand admin Imagery & Media menu - subsection description - redirects to Media Management configuration and settings",
                    _tags: "frontend,brand,admin,imagery",
                    _key: "brand.admin.imagery.media_management_desc",
                }),
                color_swatches_label: tx.t("Color swatches", {
                    _context:
                        "Brand admin Imagery & Media menu - subsection label - redirects to Color Swatches configuration and settings",
                    _tags: "frontend,brand,admin,imagery",
                    _key: "brand.admin.imagery.color_swatches_label",
                }),
                color_swatches_desc: tx.t("Upload swatches, pick colors and assign to products.", {
                    _context:
                        "Brand admin Imagery & Media menu - subsection description - redirects to Color Swatches configuration and settings",
                    _tags: "frontend,brand,admin,imagery",
                    _key: "brand.admin.imagery.color_swatches_desc",
                }),
                logos_management_label: tx.t("Custom branding", {
                    _context:
                        "Brand admin Imagery & Media menu - subsection label - redirects to Custom Branding configuration and settings",
                    _tags: "frontend,brand,admin,imagery",
                    _key: "brand.admin.imagery.logos_management_label",
                }),
                logos_management_desc: tx.t("Manage your in-app branding.", {
                    _context:
                        "Brand admin Imagery & Media menu - subsection description - redirects to Custom Branding configuration and settings",
                    _tags: "frontend,brand,admin,imagery",
                    _key: "brand.admin.imagery.logos_management_desc",
                }),
                watermarking_label: tx.t("Watermarking", {
                    _context:
                        "Brand admin Imagery & Media menu - subsection label - redirects to Watermarking configuration and settings",
                    _tags: "frontend,brand,admin,imagery",
                    _key: "brand.admin.imagery.watermarking_label",
                }),
                watermarking_desc: tx.t("Manage settings for watermarking of product images.", {
                    _context:
                        "Brand admin Imagery & Media menu - subsection description - redirects to Watermarking configuration and settings",
                    _tags: "frontend,brand,admin,imagery",
                    _key: "brand.admin.imagery.watermarking_desc",
                }),
            },
            payment: {
                title: tx.t("Payment", {
                    _context: "Brand admin menu - Subsection title - Admin page menu Payment submenu",
                    _tags: "frontend,brand,admin,payment",
                    _key: "brand.admin.payment.title",
                }),
                payment_preferences_label: tx.t("Payment preferences", {
                    _context:
                        "Brand admin Payment menu - subsection label - redirects to Payment Preferences configuration and settings",
                    _tags: "frontend,brand,admin,payment",
                    _key: "brand.admin.payment.payment_preferences_label",
                }),
                payment_preferences_desc: tx.t("Configure preferences for payment methods.", {
                    _context:
                        "Brand admin Payment menu - subsection description - redirects to Payment Preferences configuration and settings",
                    _tags: "frontend,brand,admin,payment",
                    _key: "brand.admin.payment.payment_preferences_desc",
                }),
                payment_configurations_label: tx.t("Payment configurations", {
                    _context:
                        "Brand admin Payment menu - subsection label - redirects to Payment Configurations configuration and settings",
                    _tags: "frontend,brand,admin,payment",
                    _key: "brand.admin.payment.payment_configurations_label",
                }),
                payment_configurations_desc: tx.t("Centralized payment configurations for easy payment setup.", {
                    _context:
                        "Brand admin Payment menu - subsection description - redirects to Payment Configurations configuration and settings",
                    _tags: "frontend,brand,admin,payment",
                    _key: "brand.admin.payment.payment_configurations_desc",
                }),
            },
            customizations: {
                title: tx.t("Customizations", {
                    _context: "Brand admin menu - Subsection title - Admin page menu Customizations submenu",
                    _tags: "frontend,brand,admin,customizations",
                    _key: "brand.admin.customizations.title",
                }),
                manage_logo_label: tx.t("Manage logo", {
                    _context:
                        "Brand admin Customizations menu - subsection label - redirects to Manage Logo configuration and settings",
                    _tags: "frontend,brand,admin,customizations",
                    _key: "brand.admin.customizations.manage_logo_label",
                }),
                manage_logo_desc: tx.t("Manage uploaded logos for customizable products.", {
                    _context:
                        "Brand admin Customizations menu - subsection desciption - redirects to Manage Logo configuration and settings",
                    _tags: "frontend,brand,admin,customizations",
                    _key: "brand.admin.customizations.manage_logo_desc",
                }),
            },
            title: tx.t("Admin", {
                _context: "Brand admin menu - page title - Admin page title",
                _tags: "frontend,brand,admin",
                _key: "brand.admin.title",
            }),
            brand_admin_title: tx.t("Brand Admin", {
                _context: "Brand admin menu - Menu title - Admin page menu title breadcrumb",
                _tags: "frontend,brand,admin",
                _key: "brand.admin.brand_admin_title",
            }),
        },
    },
};
